export const isTaskCompleted = (task) => {
    return task.taskStatus === "COMPLETED";
};
export const getTasksByParentId = (tasks, parentId) => {
    return tasks.filter((task) => task.parent?.id === parentId);
};
export const countCompletedTasks = (tasks) => {
    return tasks.filter(isTaskCompleted).length;
};
export const calculateSectionStats = (level1Task, level2Tasks) => {
    const sectionSubtasks = getTasksByParentId(level2Tasks, level1Task.id);
    // If section has no subtasks, treat the section itself as the subtask
    if (sectionSubtasks.length === 0) {
        return {
            sectionId: level1Task.id,
            title: level1Task.title,
            totalSubtasks: 1,
            completedSubtasks: isTaskCompleted(level1Task)
                ? 1
                : 0,
        };
    }
    // Section has subtasks: include the section task itself + all subtasks
    const totalSubtasks = 1 + sectionSubtasks.length; // 1 for section + subtasks
    const sectionCompleted = isTaskCompleted(level1Task) ? 1 : 0;
    const subtasksCompleted = countCompletedTasks(sectionSubtasks);
    const completedSubtasks = sectionCompleted + subtasksCompleted;
    return {
        sectionId: level1Task.id,
        title: level1Task.title,
        totalSubtasks: totalSubtasks,
        completedSubtasks: completedSubtasks,
    };
};
export const calculateAllSectionStats = (level1Tasks, level2Tasks) => {
    return level1Tasks.map((level1Task) => calculateSectionStats(level1Task, level2Tasks));
};
export const calculateOverallCounts = (level1Tasks, level2Tasks) => {
    let totalTasks = 0;
    let completedTasks = 0;
    level1Tasks.forEach((level1Task) => {
        const sectionSubtasks = getTasksByParentId(level2Tasks, level1Task.id);
        if (sectionSubtasks.length === 0) {
            // Section with no subtasks: count the section itself
            totalTasks += 1;
            if (isTaskCompleted(level1Task)) {
                completedTasks += 1;
            }
        }
        else {
            // Section with subtasks: count the section itself + all subtasks
            totalTasks += 1 + sectionSubtasks.length; // 1 for section + subtasks
            // Count completed: section + completed subtasks
            const sectionCompleted = isTaskCompleted(level1Task) ? 1 : 0;
            const subtasksCompleted = countCompletedTasks(sectionSubtasks);
            completedTasks += sectionCompleted + subtasksCompleted;
        }
    });
    return {
        totalTasks: totalTasks,
        completedTasks: completedTasks,
    };
};
export const calculateTransitionProgress = (transitionTaskId, level1Tasks, level2Tasks) => {
    const sections = calculateAllSectionStats(level1Tasks, level2Tasks);
    const { totalTasks, completedTasks } = calculateOverallCounts(level1Tasks, level2Tasks);
    return {
        transitionTaskId,
        totalTasks,
        completedTasks,
        sections,
    };
};
//# sourceMappingURL=transitionProgressCalculator.js.map